export const ARCHE_ID = 'arche_advertising_optimization';
export const ARCHE_PATH = `/a/${ARCHE_ID}`;

/**
 * Targeting choices offered by the placement form — deliberately short. The
 * values are Google criterion ids (geo target / language constants), which
 * the API validates and the deploy sends verbatim. The first entry of each is
 * the default, matching the server's default (US / English).
 */
export const PLACEMENT_COUNTRIES = [
  { id: '2840', label: 'United States' },
  { id: '2124', label: 'Canada' },
  { id: '2826', label: 'United Kingdom' },
  { id: '2036', label: 'Australia' },
] as const;

export const PLACEMENT_LANGUAGES = [
  { id: '1000', label: 'English' },
  { id: '1003', label: 'Spanish' },
  { id: '1002', label: 'French' },
] as const;

/** Max-CPC bounds in cents, mirroring ADOPT_TARGETING_LIMITS on the server. */
export const MAX_CPC_CENTS_MIN = 10;
export const MAX_CPC_CENTS_MAX = 5000;

/**
 * Google's documented ceilings on what a campaign's daily budget can cost
 * (support.google.com/google-ads/answer/1704443): up to 2× on a single day,
 * never more than 30.4× in a month. Mirrors `GOOGLE_ADS_MAX_DAILY_OVERSPEND_FACTOR`
 * / `GOOGLE_ADS_MONTHLY_CHARGE_DAYS` in `@fias/db-types` (parity pinned by
 * tests/architecture/adopt-daily-ad-limit.test.ts). Used to preview the worst
 * case of a limit before it is saved; the saved one comes from the server.
 */
export const GOOGLE_MAX_DAILY_OVERSPEND_FACTOR = 2;
export const GOOGLE_MONTHLY_CHARGE_DAYS = 30.4;

/**
 * What a $0 workspace daily ad limit means, wherever it is shown. $0 is a
 * person's explicit "no ads may run" — not the same as "not set".
 */
export const ZERO_DAILY_LIMIT_MESSAGE = 'No ads can run while the daily limit is $0.';

/**
 * Roughly what one Arche Builder message holds before it runs, in credits —
 * for the trial card's "≈ N builder messages" hint only. APPROXIMATE, not a
 * price, and not read from the server: a builder code-generation call reserves
 * for its full output cap plus its prompt, so the hold depends on the model and
 * on how big the app has grown. 41 is the start of a build (staging, a
 * 25-credit guest: "have 25, need 40.7" — docs/guest-trial.md §2); later
 * messages in a growing app hold and use more (prod averaged ≈54 credits net
 * per builder call over 60 days to 2026-10-02). So N is an optimistic count
 * of messages a visitor can START — which is the question the card answers
 * ("does this trial fund a first build?").
 */
export const APPROX_CREDITS_PER_BUILDER_MESSAGE = 41;
